var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#485A96",
  d: "M22.675 24c.732 0 1.325-.593 1.325-1.325V1.325C24 .593 23.407 0 22.675 0H1.325C.593 0 0 .593 0 1.325v21.35C0 23.407.593 24 1.325 24h21.35Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.56 24v-9.294h3.12l.466-3.622H16.56V8.77c0-1.048.292-1.763 1.796-1.763l1.918-.001v-3.24c-.332-.044-1.47-.142-2.795-.142-2.766 0-4.659 1.688-4.659 4.788v2.67H9.691v3.623h3.128V24h3.74Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgFacebookIcon as ReactComponent };
export default __webpack_public_path__ + "924ca89ceec98f59f09526fc6b9e57d7.svg";